import { Panel } from "primereact/panel";
import { InputComponent } from "../../../components/InputComponent";
import { CatalogoService } from "../../../service/CatalogoService";
import { useForm } from "react-hook-form";
import { ClientePNService } from "../../../service/ClientePNService";
import { useEffect, useState } from "react";
import { ActvCpn } from "../../../models/cpn/ActvCpn";
import * as generic from "../../../components/Generico";
import { ProgressSpinner } from "primereact/progressspinner";
import { BottomActionBar } from "../../../components/ui/BottomActionBar";
import { InputActividadEconomica } from "../../../components/ui/Formularios/InputActividadEconomica";

export const ActividadPn = ({ id, catalogos, toast, seccion, back, next, permss, soloLectura }) => {

    const omodel = new ActvCpn({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const catalogoSrv = new CatalogoService();
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues });
    const { inDrop, inText, inNumber } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const clientepnSrv = new ClientePNService();
    const [ecuadorDD, setEcuadorDD] = useState(false);
    const [ciudadesDD, setCiudadesDD] = useState([]);
    const [ecuadorAE, setEcuadorAE] = useState(false);
    const [ciudadesAE, setCiudadesAE] = useState([]);
    const [otraSituacion, setOtraSituacion] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [siOtraFuente, setSiOtraFuente] = useState(false);
    const [tieneAnexos, setTieneAnexos] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onChangePaisDD = (e) => {
        setEcuadorDD(e.value?.cat_id === catalogos.ecuador?.cat_id);
        setValue('provincia_dd', null);
        setValue('ciudad_dd', null);
        setCiudadesDD([]);
    }

    const onChangeProvinciaDD = (e) => {
        setValue('ciudad_dd', null);
        if (!e?.value) {
            setCiudadesDD([]);
            return;
        }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudadesDD(res.data);
        });
    }

    const onChangePaisAE = (e) => {
        setEcuadorAE(e.value?.cat_id === catalogos.ecuador?.cat_id);
        setValue('provincia_ae', null);
        setValue('ciudad_ae', null);
        setCiudadesAE([]);
    }

    const onChangeSituacion = (e) => {
        setOtraSituacion(e.value?.cat_id === catalogos.otra?.cat_id);
    }

    const onChangeProvinciaAE = (e) => {
        setValue('ciudad_ae', null);
        if (!e?.value) {
            setCiudadesAE([]);
            return;
        }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudadesAE(res.data);
        });
    }

    const editFicha = () => {
        setIsLoading(true);
        clientepnSrv.consultarClientepn(id, seccion).then(res => {
            const cats = catalogos;
            const _clientepn = res.data.clientepn;
            if (res.data.ciudad_dd) {
                setCiudadesDD(res.data.ciudad_dd);
            }
            if (res.data.ciudades_ae) {
                setCiudadesAE(res.data.ciudades_ae);
            }
            setTieneAnexos(res.data.tiene_anexos || false);
            setSiOtraFuente(_clientepn?.otro_ingreso_mes > 0);
            setEcuadorDD(_clientepn.pais_dd?.cat_id === cats.ecuador?.cat_id);
            setEcuadorAE(_clientepn.pais_ae?.cat_id === cats.ecuador?.cat_id);
            setOtraSituacion(_clientepn.situacion_laboral?.cat_id === cats.otra?.cat_id);
            reset(generic.renewValues(_clientepn, omodel.model));
        }).finally(() => {
            setIsLoading(false)
        });
    }

    const onChangeOtroIngreso = (e) => {
        setSiOtraFuente(e.value > 0);
        if (!e.value || e.value === 0) {
            setValue('detalle_otro_ingreso', '');
        }
    }

    const onSubmit = (data) => {
        setIsSaving(true);
        data.seccion = seccion;
        data.ec = catalogos.ecuador.cat_id;
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa ?? null;
        clientepnSrv.editarClientepn(data).then(res => {
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <div className="fadein animation-duration-300">
            <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

                <Panel header={generic.renderPanelHeader('A.2', 'DATOS DEL DOMICILIO', 'pi pi-home')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        {inDrop('pais_dd', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisDD, val: false }, ecuadorDD ? 4 : 6)}
                        {ecuadorDD ? (
                            <>
                                {inDrop('provincia_dd', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaDD, val: false }, 4)}
                                {inDrop('ciudad_dd', ciudadesDD, { lab: omodel.optionLabel }, 4)}
                            </>
                        ) : (
                            inText('canton_dd', { icon: 'pi pi-map-marker' }, 6)
                        )}
                        {inText('direccion', { icon: 'pi pi-home' }, catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' ? 6 : 12)}
                        {catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' && (
                            <>
                                {inText('direccion_numero', { icon: 'pi pi-hashtag' }, 3)}
                                {inText('direccion_transversal', { icon: 'pi pi-qrcode' }, 3)}
                            </>
                        )}
                        <div className="col-12 mt-2 mb-2">
                            <div className="border-top-1 border-300"></div>
                        </div>
                        {!ecuadorDD && inText('codigo_postal', { icon: 'pi pi-hashtag' }, 3)}
                        {inText('telefono_domicilio', { icon: 'pi pi-phone' }, ecuadorDD ? 4 : 3)}
                        {inText('telefono_celular', { icon: 'pi pi-mobile' }, ecuadorDD ? 4 : 3)}
                        {inText('email', { icon: 'pi pi-envelope' }, ecuadorDD ? 4 : 3)}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('A.3', 'ACTIVIDAD ECONÓMICA', 'pi pi-briefcase')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        {inDrop('situacion_laboral', catalogos?.situacionLaboral, {
                            lab: omodel.optionLabel,
                            chn: onChangeSituacion,
                            ne: tieneAnexos ? true : undefined,
                            helpText: tieneAnexos ? "Para modificar esta opción, primero debe eliminar los anexos guardados en la sección final." : null
                        }, otraSituacion ? 3 : 4)}
                        {otraSituacion && inText('detalle_sl', { icon: 'pi pi-comment' }, 3)}
                        {inText('lugar_trabajo', { icon: 'pi pi-building' }, otraSituacion ? 3 : 4)}
                        {inText('cargo', { icon: 'pi pi-briefcase' }, otraSituacion ? 3 : 4)}
                        {inText('ruc', { obl: 'no', icon: 'pi pi-id-card' }, 6)}
                        {inText('tiempo_trabaja', { icon: 'pi pi-clock' }, 6)}
                        <InputActividadEconomica name="actividad_economica" control={control} modelDef={omodel.model['actividad_economica']} disabled={soloLectura} col={12} />
                        <div className="col-12 mt-2 mb-2">
                            <div className="border-top-1 border-300"></div>
                        </div>
                        {inDrop('pais_ae', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisAE, val: false }, ecuadorAE ? 4 : 6)}
                        {ecuadorAE ? (
                            <>
                                {inDrop('provincia_ae', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaAE, val: false }, 4)}
                                {inDrop('ciudad_ae', ciudadesAE, { lab: omodel.optionLabel }, 4)}
                            </>
                        ) : (
                            inText('canton_ae', { icon: 'pi pi-map-marker' }, 6)
                        )}
                        {inText('direccion_trabajo', { icon: 'pi pi-map-marker' }, 12)}
                        <div className="col-12 mt-2 mb-2">
                            <div className="border-top-1 border-300"></div>
                        </div>
                        {inNumber('ingreso_mensual', 2, true, undefined, siOtraFuente ? 3 : 4)}
                        {inNumber('egreso_mensual', 2, true, undefined, siOtraFuente ? 3 : 4)}
                        {inNumber('otro_ingreso_mes', 2, true, { func: onChangeOtroIngreso }, siOtraFuente ? 3 : 4)}
                        {siOtraFuente && inText('detalle_otro_ingreso', { obl: 'no', icon: 'pi pi-comment' }, 3)}
                        {inText('telefono_trabajo', { icon: 'pi pi-phone' }, 6)}
                        {inText('email_trabajo', { icon: 'pi pi-envelope' }, 6)}
                    </div>
                </Panel>

                <BottomActionBar onPrev={back} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
            </form>
        </div>
    )
}
